import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { useSchedule } from 'modules/shift_management/hooks/useSchedule'

import InformationTooltip from './InformationTooltip'

interface ContentProps {
  to: string
  disabled?: boolean | false
}

const Content = ({ to, disabled }: ContentProps) => {
  const [{ view }] = useSchedule()

  const trackEvent = () => {
    track(trackingEvents.shiftManagement.goToWorkAreaStart, {
      view: view.viewType,
    })
  }

  return (
    <Button.Router to={to} onClick={trackEvent} disabled={disabled} iconName="add">
      {i18n.t('settings.locations.location.work_areas.add.button')}
    </Button.Router>
  )
}

interface UrlButtonProps {
  to: string
  disabled?: boolean
}

const UrlButton = ({ to, disabled }: UrlButtonProps) => {
  if (!disabled) return <Content to={to} />

  return (
    <InformationTooltip>
      <Content to={to} disabled />
    </InformationTooltip>
  )
}

export default observer(UrlButton)
